import moment from 'moment';
import {
  ACCOUNT_SERVICE_ROOT,
  AVAILABILITY_SERVICE_ROOT
} from 'src/constants/app.constant';

const ApiBaseUrl = `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking`;

const validateArgs = (args) => {
  let isValid = true;
  Array.from(args).some((arg) => {
    if (!arg) {
      isValid = false;
      return !isValid;
    }
  });

  return isValid;
};

const Api = {
  // /appointment-types?accountId=
  async getAppointmentTypes(accountId) {
    if (!validateArgs(arguments)) return [];
    const tenantInfo = JSON.parse(localStorage.getItem('tenantInfo') || '');
    const response = await fetch(
      `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking/appointment-types?accountId=${tenantInfo.accountId}`
    );
    return response?.json();
  },

  // /appointment-types/{appointmentTypeId}/providers?accountId=
  // ${ApiBaseUrl}/appointment-types/${appointmentTypeId}/providers?accountId=${accountId}
  async getProviders(
    accountId,
    appointmentTypeId,
    syncAvailability,
    isAvailProviderCoupled,
  ) {
    if (!validateArgs(arguments)) return [];
    const tenantInfo = JSON.parse(localStorage.getItem('tenantInfo') || '');
    let response;
    if (JSON.parse(syncAvailability)) {
      if (isAvailProviderCoupled === 'true') {
        response = await fetch(
          `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/appointment-types/${appointmentTypeId}/pdds-providers?accountId=${tenantInfo.accountId}`
        );
      } else {
        response = await fetch(
          `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/pdds-providers?accountId=${tenantInfo.accountId}`
        );
      }
    } else {
      response = await fetch(
        `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking/appointment-types/${appointmentTypeId}/providers?accountId=${tenantInfo.accountId}`
      );
    }
    return response?.json();
  },

  // /providers/{providerId}/open-days?accountId=&month=&year=&appointmentLength=
  // ${ApiBaseUrl}/providers/${providerId}/open-days?accountId=${accountId}&month=${month}&year=${year}&appointmentLength=${duration}
  async getOpenDays(accountId, providerId, date, duration) {
    if (!validateArgs(arguments)) return [];
    const momentDate = moment(date);
    const month = momentDate.month();
    const year = momentDate.year();
    const response = await fetch(
      `${ApiBaseUrl}/providers/${providerId}/open-days?accountId=${accountId}&month=${month}&year=${year}&appointmentLength=${duration}`
    );

    return response?.json();
  },

  // /providers/{providerId}/open-time-slots?accountId=&date=&appointmentLength=
  async getOpenTimeSlots(accountId, providerId, day, duration) {
    if (!validateArgs(arguments)) return [];
    const date = moment(day).format('YYYY-MM-DD');
    const response = await fetch(
      `${ApiBaseUrl}/providers/${providerId}/time-slots?accountId=${accountId}&date=${date}&appointmentLength=${duration}`
    );
    return response?.json();
  },

  // /getGeoLocationList/{accountId}/{pointLatitude}/{pointLongitude}/{radius}
  getGeoLocationList: async function (
    accountId,
    pointLatitude,
    pointLongitude,
    radius,
    zipCode,
    isRequireMinMax
  ) {
    let path = '';
    if (zipCode && !pointLatitude && !pointLongitude) {
      path = `&radius=${radius}&zipCode=${zipCode}`;
    } else if (pointLatitude && pointLongitude) {
      path = `&pointLatitude=${pointLatitude}&pointLongitude=${pointLongitude}&radius=${radius}`;
    }
    if (path) {
      const response = await fetch(
        `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/postal-location?accountId=${accountId}${path}&isRequireMinMax=${isRequireMinMax}`
      );
      return response?.json();
    }
  },
  getLocations: async function (accountId, includeAllLocations) {
    if (!validateArgs(arguments)) return [];
    
    let queryParameters = {
      accountId,
      includeAllLocations,
    }

    // Filter out any undefined query parameters
    queryParameters = Object.fromEntries(
      Object.entries(queryParameters).filter(([_, value]) => value !== undefined)
    );

    const queryString = Object.keys(queryParameters)
      .map((key) => key + '=' + queryParameters[key])

    const response = await fetch(
      `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking/getLocationsList?${queryString.join('&')}`
    );
    
    return response?.json();
  },
  // /availability-virtual-calendar?accountId
  getVirtualCalender: async function (
    accountId,
    appointmentTypeId,
    date,
    syncAvailability,
    interval,
    apptDuration,
    isAvailProviderCoupled,
    placeholderProviderId
  ) {
    if (!validateArgs(arguments)) return {};
    const momentDate = moment(date);
    const month = momentDate.month();
    const year = momentDate.year();
    const response = await fetch(
      `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/availability-virtual-calendar?accountId=${accountId}&appointmentTypeId=${appointmentTypeId}&monthOfYear=${month}&year=${year}&syncAvailability=${syncAvailability}&interval=${interval}&apptDuration=${apptDuration}&isAvailProviderCoupled=${isAvailProviderCoupled}&placeholderProviderId=${placeholderProviderId}`
    );
    return response?.json();
  },

  // /is-multi-location-account?accountId=
  getIsMultiLocation: async function (accountId) {
    if (!validateArgs(arguments)) return {};
    const tenantInfo = JSON.parse(localStorage.getItem('tenantInfo') || '');
    const response = await fetch(
      `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking/is-multi-location-account?accountId=${tenantInfo.accountId}`
    );
    return response?.json();
  },

  getRegisterAddress: async function (accountId) {
    if (!validateArgs(arguments)) return [];

    const response = await fetch(
      `${ACCOUNT_SERVICE_ROOT}/public/accounts/${accountId}/settings`
    );
    return response?.json();
  },

  async getPatientPortalPublicGeneralSettings(accountId) {
    if (!validateArgs(arguments)) return [];
    const tenantInfo = JSON.parse(localStorage.getItem('tenantInfo') || '');
    const response = await fetch(
      `${ACCOUNT_SERVICE_ROOT}/public/appointment-booking/general-settings?accountId=${tenantInfo.accountId}`
    );
    return response?.json();
  },

  getPddsAppointmentTypes: async function (accountId, syncAvailability, isAvailProviderCoupled) {
    if (!validateArgs(arguments)) return {};

    let verifyOabProviders = false;
    if (syncAvailability === 'true' && isAvailProviderCoupled === 'false') {
      verifyOabProviders = true;
    }
    const response = await fetch(
      `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/pdds-appointment-types?accountId=${accountId}&verifyOabProviders=${verifyOabProviders}`
    );
    return response?.json();
  },

  getPddsLocations: async function (accountId) {
    if (!validateArgs(arguments)) return {};
    const response = await fetch(
      `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/pdds-locations?accountId=${accountId}`
    );
    return response?.json();
  },

  getVirtualCalenderByLocation: async function (
    accountId,
    appointmentTypeId,
    date,
    syncAvailability,
    duration,
    locationId,
    providerId,
  ) {
    if (!validateArgs(arguments)) return {};
    let path = `&locationId=${locationId}` 
    const response = await fetch(
      `${AVAILABILITY_SERVICE_ROOT}/public/appointment-booking/availability-virtual-calendar?accountId=${accountId}&appointmentTypeId=${appointmentTypeId}&syncAvailability=${syncAvailability}&interval=${duration}&selectedDate=${date}${path}`
    );
    return response?.json();
  },

  saveToken: async function(accountId, token) {
    const payload = {
      accountId,
      token,
    };
    const url = `${ACCOUNT_SERVICE_ROOT}/public/google-reserve/token`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return response.status;
  }
};
export default Api;
